<section class="director-dashboard">
  <div class="dd-container">

    <!-- ===== Inline Agenda View ===== -->
    <ng-container *ngIf="showAgendaView && nextMeeting">
      <div class="dd-agenda-fullview">
        <div class="dd-card dd-agenda-fullview-header">
          <button type="button" class="dd-back-btn" (click)="backFromAgenda()" title="Back to dashboard">
            <i class="fa fa-angle-left"></i>
          </button>
          <div class="dd-agenda-fullview-meta">
            <h2 class="dd-agenda-fullview-title">{{ meetingTypeLabel(nextMeeting) }}
              <span *ngIf="nextMeetingCompanyName"> — {{ nextMeetingCompanyName }}</span>
            </h2>
            <p class="dd-agenda-fullview-sub">{{ meetingTimeDisplay(nextMeeting) }}</p>
          </div>
        </div>
        <div class="dd-card dd-agenda-fullview-body">
          <app-meetingagenda
            [meetingObject]="nextMeeting"
            [agendaObject]="nextMeeting.Agenda"
            [clickedAgenda]="null"
            [loadAgendaFromPagignation]="null"
            (emitFileURL)="onAgendaFileURL($event)">
          </app-meetingagenda>
        </div>
      </div>
    </ng-container>

    <!-- ===== Normal Dashboard View ===== -->
    <ng-container *ngIf="!showAgendaView">
    <header class="dd-header">
      <div>
        <p class="dd-greeting">{{ greeting }}, {{ userDisplayName }}</p>
        <h1 class="dd-headline" [class.dd-headline--loading]="isLoading">{{ nextMeetingHeadline }}</h1>
      </div>
    </header>

    <div *ngIf="isLoading" class="dd-card dd-state dd-state--loading">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      Loading your meetings…
    </div>
    <div *ngIf="!isLoading && isEmpty && !earlierTodayMeetings.length" class="dd-card dd-state">No upcoming meetings found.</div>

    <ng-container *ngIf="!isLoading && nextMeeting">
      <article class="dd-card dd-next-meeting">
        <div class="dd-next-top">
          <div class="dd-date-block">
            <div class="dd-date-month">{{ meetingMonthShort(nextMeeting) }}</div>
            <div class="dd-date-day">{{ meetingDayNum(nextMeeting) }}</div>
            <div class="dd-date-weekday">{{ meetingWeekdayShort(nextMeeting) }}</div>
          </div>
          <div class="dd-next-content">
            <span class="dd-live-badge" *ngIf="nextMeetingIsLive">
              Live · ends {{ nextMeetingLiveEndLabel }}
            </span>
            <h2 class="dd-meeting-name">{{ meetingTypeLabel(nextMeeting) }}</h2>
            <div class="dd-time-row">
              {{ meetingTimeDisplay(nextMeeting) }} · {{ nextMeetingDurationLabel }}
            </div>
            <p class="dd-company-title">{{ nextMeetingCompanyName }}</p>
            <p class="dd-venue">{{ meetingVenue(nextMeeting) }}</p>
            <div class="dd-meta-row">
              <span>{{ nextMeetingAgendaCount }} agenda items</span>
              <span>{{ nextMeetingDocumentCount }} documents</span>
              <span>{{ nextMeetingAttendeeCount }} attendees</span>
            </div>
          </div>
        </div>
        <div class="dd-action-row">
          <button type="button" class="btn dd-btn-primary" (click)="reviewAgenda()">
            Review agenda <i class="fa fa-external-link"></i>
          </button>
          <button type="button" class="btn dd-btn-secondary" (click)="joinMeeting(nextMeeting)">
            Join meeting
          </button>
          <button
            type="button"
            class="btn dd-btn-secondary"
            *ngIf="nextMeeting.MeetType != 'Circular Resolution'"
            (click)="openParticipantsModal()">
            View participants
          </button>
          <span
            ngbDropdown
            class="dd-calendar-dropdown"
            *ngIf="calendarUrls && nextMeeting.MeetType != 'Circular Resolution'">
            <button type="button" class="btn dd-btn-secondary" ngbDropdownToggle>
              Add to calendar
            </button>
            <div ngbDropdownMenu class="dd-calendar-menu">
              <a class="dropdown-item" [href]="calendarUrls.iCalendar" target="_blank" rel="noopener">ICalendar</a>
              <a class="dropdown-item" [href]="calendarUrls.google" target="_blank" rel="noopener">Google Calendar</a>
              <a class="dropdown-item" [href]="calendarUrls.outlook" target="_blank" rel="noopener">Outlook</a>
              <a class="dropdown-item" [href]="calendarUrls.yahoo" target="_blank" rel="noopener">Yahoo Calendar</a>
              <a class="dropdown-item" [href]="calendarUrls.microsoft" target="_blank" rel="noopener">Microsoft Calendar</a>
            </div>
          </span>
        </div>
      </article>

      <article class="dd-card dd-agenda-preview" *ngIf="agendaPreviewItems.length">
        <button type="button" class="dd-agenda-toggle" (click)="toggleAgendaPreview()">
          <span>Agenda preview</span>
          <span class="dd-agenda-count">{{ nextMeetingAgendaCount }} items</span>
          <i class="fa" [ngClass]="agendaPreviewExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
        <div class="dd-agenda-list-wrap" *ngIf="agendaPreviewExpanded">
        <ul class="dd-agenda-list">
          <li *ngFor="let agenda of agendaPreviewItems; let i = index">
            <button
              type="button"
              class="dd-agenda-item-btn"
              title="View agenda"
              (click)="openAgendaPdfViewer(agenda)">
              <span class="dd-agenda-index-box">{{ formatAgendaIndex(agenda, i) }}</span>
              <span class="dd-agenda-title">{{ agenda.AgendaTitle }}</span>
              <span class="dd-agenda-attach">
                <i class="fa fa-paperclip" aria-hidden="true"></i>
                <span>{{ agendaAttachmentCount(agenda) }}</span>
              </span>
            </button>
          </li>
        </ul>
        </div>
      </article>

      <article class="dd-card dd-widget dd-documents-widget">
        <button type="button" class="dd-widget-toggle" (click)="toggleDocumentsWidget()">
          <span class="dd-widget-title">
            <i class="fa fa-file-text-o dd-widget-icon" aria-hidden="true"></i>
            Documents
          </span>
          <span class="dd-widget-count">{{ documentsWidgetItems.length }} items</span>
          <i class="fa" [ngClass]="documentsWidgetExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
        <div class="dd-widget-body" *ngIf="documentsWidgetExpanded">
          <p class="dd-widget-empty" *ngIf="!documentsWidgetItems.length">No documents available for this meeting.</p>
          <ul class="dd-doc-list" *ngIf="documentsWidgetItems.length">
            <li *ngFor="let doc of documentsWidgetItems">
              <button type="button" class="dd-doc-item-btn" (click)="openDocumentWidget(doc)">
                <span class="dd-doc-label">{{ doc.label }}</span>
                <span class="dd-doc-name" *ngIf="doc.name && doc.name !== doc.label">{{ doc.name }}</span>
                <span class="dd-doc-action" aria-hidden="true">
                  <i class="fa" [ngClass]="doc.fileExt === 'pdf' ? 'fa-eye' : 'fa-download'"></i>
                </span>
              </button>
            </li>
          </ul>
        </div>
      </article>

      <article class="dd-card dd-upcoming" *ngIf="upcomingMeetings.length">
        <div class="dd-upcoming-header">
          <h3>Upcoming meetings</h3>
          <button type="button" class="dd-link-btn" (click)="viewCalendar()">View calendar →</button>
        </div>
        <div class="dd-upcoming-list">
          <button
            type="button"
            class="dd-upcoming-row"
            *ngFor="let meeting of upcomingMeetings"
            (click)="openMeetingDetails(meeting)">
            <div class="dd-upcoming-date">
              <div>{{ meetingMonthShort(meeting) }}</div>
              <div class="dd-upcoming-day">{{ meetingDayNum(meeting) }}</div>
            </div>
            <div class="dd-upcoming-info">
              <div class="dd-upcoming-title">{{ meetingTypeLabel(meeting) }}</div>
              <div class="dd-upcoming-sub">{{ upcomingMeta(meeting) }}</div>
            </div>
          </button>
        </div>
      </article>
    </ng-container>

    <article class="dd-card dd-earlier-today" *ngIf="!isLoading && !showAgendaView && earlierTodayMeetings.length">
      <div class="dd-upcoming-header">
        <h3>Earlier today</h3>
      </div>
      <div class="dd-upcoming-list">
        <div
          class="dd-upcoming-row dd-upcoming-row--muted"
          *ngFor="let meeting of earlierTodayMeetings">
          <div class="dd-upcoming-date dd-upcoming-date--muted">
            <div>{{ meetingMonthShort(meeting) }}</div>
            <div class="dd-upcoming-day">{{ meetingDayNum(meeting) }}</div>
          </div>
          <div class="dd-upcoming-info">
            <div class="dd-upcoming-title-row">
              <div class="dd-upcoming-title">{{ meetingTypeLabel(meeting) }}</div>
              <span class="dd-missed-tag" *ngIf="isMeetingMissed(meeting)">Missed</span>
            </div>
            <div class="dd-upcoming-sub">{{ upcomingMeta(meeting) }}</div>
          </div>
        </div>
      </div>
    </article>

    <article class="dd-card dd-calendar" *ngIf="!isLoading && !showAgendaView">
      <div class="dd-calendar-header">
        <h3>Calendar</h3>
      </div>
      <app-calendar-task
        [refreshData]="calendarRefreshToken"
        [prefetchedMeetings]="calendarPrefetchedMeetings"
        [prefetchedUserList]="calendarPrefetchedUserList"
        [rowFive]="false"
        (outputStatus)="onCalendarOutput($event)">
      </app-calendar-task>
    </article>

    <div class="dd-company-widgets" *ngIf="!isLoading && !showAgendaView">
      <div class="row dashboard-widget-strip mb-0">
        <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col">
          <div class="col-md-12"
               [appHasPermission]="{'Url': 'stockPrice', 'method':'get', 'menu': 'Dashboard'}">
            <section class="card dashboard-widget-card widget-bg-green" order-id="card-2">
              <div class="card-heading widget-card-content" (click)="openDashboardModal('ShareInfoModal')">
                <div class="widget-icon-wrapper widget-icon-green">
                  <img src="/assets/images/share-information.png" alt="share information" class="widget-icon">
                </div>
                <div class="widget-title">Share Information</div>
                <div class="widget-arrow">
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div class="modal fade" id="ShareInfoModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content" style="background: transparent;">
                    <div class="modal-body">
                      <app-stock-price *ngIf="shareInfoWidgetActive" [data]="companyData"></app-stock-price>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <!-- Financials widget hidden temporarily — re-enable when needed
        <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col">
          <div class="col-md-12"
               [appHasPermission]="{'Url': 'financialResults', 'method':'get', 'menu': 'Dashboard'}">
            <section class="card dashboard-widget-card widget-bg-red" order-id="card-2">
              <div class="card-heading widget-card-content" (click)="openDashboardModal('FinancialsModal')">
                <div class="widget-icon-wrapper widget-icon-red">
                  <img src="/assets/images/financials.png" alt="Financials" class="widget-icon">
                </div>
                <div class="widget-title">Financials</div>
                <div class="widget-arrow">
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div class="modal fade" id="FinancialsModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content" style="background: transparent;">
                    <div class="modal-body">
                      <app-financials *ngIf="financialsWidgetActive"></app-financials>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        -->
        <!-- Key Ratios widget hidden temporarily — re-enable when needed
        <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col"
             [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
          <section class="card dashboard-widget-card widget-bg-blue" order-id="card-2">
            <div class="card-heading widget-card-content" (click)="openDashboardModal('KeyRatiosModal')">
              <div class="widget-icon-wrapper widget-icon-blue">
                <img src="/assets/images/key-ratios.png" alt="KeyRatios" class="widget-icon">
              </div>
              <div class="widget-title">Key Ratios</div>
              <div class="widget-arrow">
                <i class="fa fa-arrow-right"></i>
              </div>
            </div>
            <div class="modal fade" id="KeyRatiosModal" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" style="background: transparent;">
                  <div class="modal-body">
                    <app-key-ratios *ngIf="keyRatiosWidgetActive"></app-key-ratios>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        -->
        <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col"
             [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
          <section class="card dashboard-widget-card widget-bg-purple" order-id="card-2">
            <div class="card-heading widget-card-content" (click)="openDashboardModal('orgChartModal')">
              <div class="widget-icon-wrapper widget-icon-purple">
                <img src="/assets/images/organization-charts.png" alt="orgchart" class="widget-icon">
              </div>
              <div class="widget-title">Organization Chart</div>
              <div class="widget-arrow">
                <i class="fa fa-arrow-right"></i>
              </div>
            </div>
          </section>
          <app-orgchart *ngIf="orgChartWidgetActive"></app-orgchart>
        </div>
      </div>
    </div>
    </ng-container><!-- end !showAgendaView -->
  </div>

  <div
    class="dd-participants-overlay"
    *ngIf="participantsModalOpen"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dd-participants-modal-title"
    (click)="closeParticipantsModal()">
    <div class="dd-participants-modal" (click)="$event.stopPropagation()">
      <header class="dd-participants-modal-header">
        <div>
          <h3 id="dd-participants-modal-title">Participants</h3>
          <p class="dd-participants-modal-sub" *ngIf="nextMeeting">
            {{ meetingTypeLabel(nextMeeting) }}
            <span *ngIf="participantsHasAttendance"> · {{ participantsWidgetTotal }} total</span>
            <span *ngIf="!participantsHasAttendance"> · {{ participantsWidgetTotal }} invited</span>
          </p>
        </div>
        <button type="button" class="dd-participants-close" aria-label="Close" (click)="closeParticipantsModal()">
          <i class="fa fa-times"></i>
        </button>
      </header>
      <div class="dd-participants-modal-body">
        <ng-container *ngIf="participantsHasAttendance">
          <div class="dd-participant-cols">
            <div class="dd-participant-col">
              <div class="dd-participant-col-head dd-participant-col-head--attending">
                <span>Attending</span>
                <strong>{{ participantsAttendedCount }}</strong>
              </div>
              <ul class="dd-participant-list" *ngIf="participantsAttending.length">
                <li *ngFor="let person of participantsAttending">
                  <span class="dd-participant-name">{{ person.name }}</span>
                  <span class="dd-participant-role">{{ person.role }}</span>
                </li>
              </ul>
              <p class="dd-widget-empty" *ngIf="!participantsAttending.length">No confirmations yet.</p>
            </div>
            <div class="dd-participant-col">
              <div class="dd-participant-col-head dd-participant-col-head--not-attending">
                <span>Not attending</span>
                <strong>{{ participantsNotAttendedCount }}</strong>
              </div>
              <ul class="dd-participant-list" *ngIf="participantsNotAttending.length">
                <li *ngFor="let person of participantsNotAttending">
                  <span class="dd-participant-name">{{ person.name }}</span>
                  <span class="dd-participant-role">{{ person.role }}</span>
                </li>
              </ul>
              <p class="dd-widget-empty" *ngIf="!participantsNotAttending.length">None declined.</p>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!participantsHasAttendance">
          <p class="dd-widget-note" *ngIf="participantsInvited.length">
            Attendance responses are not recorded yet. Invited participants:
          </p>
          <p class="dd-widget-empty" *ngIf="!participantsInvited.length">
            Attendance records yet to update.
          </p>
          <ul class="dd-participant-list dd-participant-list--invited" *ngIf="participantsInvited.length">
            <li *ngFor="let person of participantsInvited">
              <span class="dd-participant-name">{{ person.name }}</span>
              <span class="dd-participant-role">{{ person.role }}</span>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    class="dd-pdf-overlay"
    *ngIf="pdfModalOpen"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dd-pdf-modal-title"
    (click)="closeAgendaPdfModal()">
    <div class="dd-pdf-modal" (click)="$event.stopPropagation()">
      <header class="dd-pdf-modal-header">
        <div class="dd-pdf-modal-title-wrap">
          <h3 id="dd-pdf-modal-title">{{ pdfModalTitle }}</h3>
          <p class="dd-pdf-modal-sub" *ngIf="pdfModalSubtitle">{{ pdfModalSubtitle }}</p>
        </div>
        <button type="button" class="dd-pdf-close" aria-label="Close" (click)="closeAgendaPdfModal()">
          <i class="fa fa-times"></i>
        </button>
      </header>
      <div class="dd-pdf-modal-body">
        <div class="dd-pdf-loading" *ngIf="pdfLoading">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Loading document…</span>
        </div>
        <div class="dd-pdf-error" *ngIf="!pdfLoading && pdfError">{{ pdfError }}</div>
        <iframe
          *ngIf="!pdfLoading && pdfIframeUrl && !pdfError"
          class="dd-pdf-iframe"
          [src]="pdfIframeUrl"
          title="Agenda document preview"></iframe>
      </div>
    </div>
  </div>
</section>
